import { render } from "./orderCollectionItem.vue?vue&type=template&id=28458b4e&scoped=true"
import script from "./orderCollectionItem.vue?vue&type=script&lang=js"
export * from "./orderCollectionItem.vue?vue&type=script&lang=js"

import "./orderCollectionItem.vue?vue&type=style&index=0&id=28458b4e&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28458b4e"]])

export default __exports__